module.exports = __webpack_public_path__ + "static/media/g-18.c1ed17c3.jpg";